import { render, staticRenderFns } from "./GoogleRecaptchaSetting.vue?vue&type=template&id=91075882"
import script from "./GoogleRecaptchaSetting.vue?vue&type=script&lang=js"
export * from "./GoogleRecaptchaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports